var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"84f526370d9b98d3993a1d48ee4020102d5f85f8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["syntho-mobile@syntho"]={id:"84f526370d9b98d3993a1d48ee4020102d5f85f8"};
      